import  * as actions from '../actions/';
import { IUserContext } from '../state/IUserContext';

export const initialState: IUserContext = {
  userName: 'Anonymous',
  user: undefined,
  isAuthenticated: false,
  loading: false,
  errors: undefined,
  claims: undefined,
  userPermissions: undefined,
  permissionsLoaded: false,
  submittingEntities: undefined,
  submittingEntitiesLoaded: false,
  authToken: undefined,
  availableRoles: undefined
}

export function userContextReducer(state = initialState, action: actions.Actions): IUserContext {
  switch (action.type) {
    case actions.LOGOUT:
      return { ...state, loading: true };
    case actions.LOGOUT_COMPLETE:
      return {
        ...state,
        ...initialState
      };
    //case dashboardActions.querySuccessType(ModuleConfiguration.moduleName, UpdateParametersModel)
    case actions.USER_IDENTITY_UPDATED:
      action = action as actions.UserIdentityUpdatedAction;
      return {
        ...state,
        loading: false,
        isAuthenticated: true,
        userName: action.payload.claims.preferred_username,
        authToken: action.payload.authToken,
        claims: action.payload.claims
      };
    case actions.QUERY_AVAILABLE_ROLES_SUCCESS:
      return {
        ...state,
        availableRoles: (action as actions.QueryAvailableRolesSuccessAction).payload.items
      };
    case actions.GET_CURRENT_USER_PERMISSIONS_SUCCESS:
      return {
        ...state,
        userPermissions: (action as actions.GetCurrentUserPermissionsSuccessAction).payload.permissions,
        permissionsLoaded: true
      };
    case actions.GET_CURRENT_USER_SUBMITTING_ENTITIES_SUCCESS:
      return {
        ...state,
        submittingEntities: (action as actions.GetCurrentUserSubmittingEntitiesSuccessAction).payload.submittingEntities,
        submittingEntitiesLoaded: true
      };
    case actions.GET_CURRENT_USER_SUCCESS:
      return {
        ...state,
        user: (action as actions.GetCurrentUserProfileSuccessAction).payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/reducers/user-context.reducer.ts